import { render, staticRenderFns } from "./SaitenEditTab.vue?vue&type=template&id=b2084b72&scoped=true&"
import script from "./SaitenEditTab.vue?vue&type=script&lang=js&"
export * from "./SaitenEditTab.vue?vue&type=script&lang=js&"
import style0 from "./SaitenEditTab.vue?vue&type=style&index=0&id=b2084b72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2084b72",
  null
  
)

export default component.exports